import { render, staticRenderFns } from "./ReportEditor.vue?vue&type=template&id=1190263c&"
import script from "./ReportEditor.vue?vue&type=script&lang=ts&"
export * from "./ReportEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports